import { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {

}

const IconPlay = (props: Props) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="inherit"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M2.44531 2.50896C2.44531 1.81761 2.44531 1.47193 2.58946 1.28138C2.71504 1.11538 2.90698 1.01266 3.11476 1.00025C3.35327 0.98601 3.64089 1.17776 4.21613 1.56125L11.702 6.5518C12.1773 6.86867 12.4149 7.02711 12.4977 7.22681C12.5701 7.4014 12.5701 7.59762 12.4977 7.77221C12.4149 7.97191 12.1773 8.13035 11.702 8.44722L4.21613 13.4378C3.64089 13.8213 3.35327 14.013 3.11476 13.9988C2.90698 13.9864 2.71504 13.8836 2.58946 13.7176C2.44531 13.5271 2.44531 13.1814 2.44531 12.4901V2.50896Z"
        fill="inherit"
      />
    </g>
  </svg>
);

export default IconPlay;
